export default {"src":"/_next/static/media/ellipses.0e96ad66.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};